import { PropsWithChildren } from 'react';
import { ThemeProvider } from 'styled-components';
import { LisScope } from './lis-scope';
import { lisTheme } from './theme';

export interface LisUiRootProps {
  className?: string;
}

/**
 * Mounts the styled-components `ThemeProvider` (so `p.theme.*` works in
 * every `src/ui` primitive) and roots the `--lis-*` CSS custom properties
 * on its own element via `LisScope`. Wrap any tree that renders `src/ui`
 * components with this — the wizard's page root, or a test's
 * `renderWithProviders` output.
 */
export function LisUiRoot({ children, className }: PropsWithChildren<LisUiRootProps>) {
  return (
    <ThemeProvider theme={lisTheme}>
      <LisScope className={className}>{children}</LisScope>
    </ThemeProvider>
  );
}

export default LisUiRoot;
